import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ element, roles }) {
  const token = localStorage.getItem('token');
  const user = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch { return {}; }
  })();

  if (!token) return <Navigate to="/login" replace />;

  // users.role holds one value, so an admin who is also a paying member is only
  // ever 'tenantadmin'. Gating the member pages on the role alone meant an admin
  // could not open or renew their own membership: /renew bounced to /login, and
  // logging back in returned them to /admin. What actually entitles someone to
  // the member pages is having a member record, which login reports as
  // has_membership — so that opens the 'member' routes as well as the role does.
  const allowed = roles
    ? roles.includes(user.role) || (roles.includes('member') && user.has_membership === true)
    : true;
  if (!allowed) return <Navigate to="/login" replace />;
  return element;
}

export default ProtectedRoute;
